export function parseJSONWithoutException(jsonStuff: string) {
  try {
    return JSON.parse(jsonStuff);
  } catch (e) {
    if (e instanceof SyntaxError) {
      return null;
    } else {
      throw e;
    }
  }
}

export const getAuth0Expiry = (token: string) => {
  if (!token) {
    return -1;
  }
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      Buffer.from(base64, 'base64')
        .toString('utf8')
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    const jsonParsedPayload = JSON.parse(jsonPayload);
    if (jsonParsedPayload?.exp) {
      return jsonParsedPayload.exp as number;
    }
    return -1;
  } catch {
    return -1;
  }
};
